import { atom } from 'jotai';

export const apiErrorAtom = atom<{ errorId: string, uid: string, wid: string } | null>(null);
